module.exports = __webpack_public_path__ + "img/4.10f4ceef.jpg";